<template>
  <div class="company-info">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in cards" :key="index" :label="item.label" :name="item.name + index">
        <company-base-info v-if="item.name === '基本信息'" :company-name="companyName" />
        <multi-dimensional-info v-else-if="item.name === '企业风险' || item.name === '知识产权' || item.name === '高质分析' || item.name === '服务过(中)的企业'" :dimensional-item="{ companyName: companyName, dimension: item.dimension }" :current-key="selectKey" :per-key="item.name" :select-type="item.name === '服务过(中)的企业' ? 'company_data' : 'resources'" />
        <dimension-info v-else :company="{ company_name: companyName, key: item.name }" :select-key="selectKey" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CompanyBaseInfo from "./CompanyBaseInfo.vue";
import DimensionInfo from "./DimensionInfo.vue";
import MultiDimensionalInfo from "./MultiDimensionalInfo.vue";
export default {
  name: 'CompanyInfo',
  components: {
    CompanyBaseInfo,
    DimensionInfo,
    MultiDimensionalInfo
  },
  props: {
    companyName: {
      type: String,
      default: ''
    }
  },
  computed: {
    cards () {
      const cardData = []
      const riskItems = ['失信被执行人', '终本案件', '司法案件', '限制高消费', '被执行人', '裁判文书', '股权质押', '行政处罚']
      const riskDimension = []
      const intellectualItem = ['商标信息', '专利信息', '软件著作权', '备案网站', '标准信息']
      const intellectualDimension = []
      const analysisItem = ['控制企业', '对外投资', '总公司', '分支机构', '荣誉', '融资信息-创投融资', '供应商', '客户', '实际控制人', '股东信息']
      const analysisDimension = []
      const servedItems = ['基础信息', '订单信息']
      const servedDimension = []

      this.companyCard.forEach(item => {
        // 判断是否为特定项
        if (riskItems.includes(item.key)) {
          // riskDimension.push(item.key + '(' + item.total + ')')
          riskDimension.push({ key: item.key, total: item.total })
        } else if (intellectualItem.includes(item.key)) {
          intellectualDimension.push({ key: item.key, total: item.total })
        } else if (analysisItem.includes(item.key)) {
          analysisDimension.push({ key: item.key, total: item.total })
        } else if (servedItems.includes(item.key)) {
          servedDimension.push({ key: item.key, total: item.total })
        } else {
          cardData.push({ label: item.key, name: item.key, dimension: [item] })
        }
      })

      if (cardData.find(item => item.label === '基本信息')) {
        analysisDimension.unshift({ key: '基本信息', total: 1 });
      }

      // 如果有特殊维度数据，将它们加入到 cardData 中
      if (riskDimension.length > 0) {
        cardData.push({
          label: '企业风险',
          name: '企业风险',
          dimension: riskDimension
        })
      }

      if (intellectualDimension.length > 0) {
        cardData.push({
          label: '知识产权',
          name: '知识产权',
          dimension: intellectualDimension
        })
      }

      if (analysisDimension.length > 0) {
        cardData.push({
          label: '高质分析',
          name: '高质分析',
          dimension: analysisDimension
        })
      }

      if (servedDimension.length > 0) {
        cardData.push({
          label: '服务过(中)的企业',
          name: '服务过(中)的企业',
          dimension: servedDimension
        })
      }

      const priorityOrder = ['基本信息', '高质分析', '资质证书', '知识产权', '企业风险']

      // 按照 priorityOrder 中的顺序对 cardData 排序
      cardData.sort((a, b) => {
        const aIndex = priorityOrder.indexOf(a.label);
        const bIndex = priorityOrder.indexOf(b.label);

        // 如果 label 在 priorityOrder 中没有找到，则放在最后
        return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
      })

      return cardData
    }
  },
  watch: {
    companyName: {
      immediate: true,
      handler (val) {
        if (val) this.fetchData()
      }
    },
    cards: {
      immediate: true,
      handler (val) {
        if (this.cards.length > 0) {
          this.activeName = this.cards[0].name + '0'
          this.selectKey = this.cards[0].name
        }
      }
    }
  },
  data () {
    return {
      activeName: '',
      selectKey: '',
      companyCard: [],
    }
  },
  methods: {
    fetchData () {
      this.$axios.get('/api/admin/upload_task_info/dimension?company_name=' + this.companyName, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyCard = data.data
          }
        })
    },
    handleClick (tab, event) {
      this.selectKey = tab.label
    }
  }
}
</script>
<style lang="stylus" scoped>
.company-info >>> .el-tabs__content {
  height: 80vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyInfo.vue